/**
 * Learn more about light and dark modes:
 * https://docs.expo.dev/guides/color-schemes/
 */

import { Colors } from '@/constants/theme';

/**
 * Dark mode dimatikan (Fase 1 redesign) — selalu kembalikan palet light.
 * Palet dark lama memakai background ungu gelap #1a1525 yang membuat teks
 * susah terbaca; sekarang background selalu putih dan brand purple hanya
 * menjadi aksen.
 */
export function useTheme() {
  return Colors.light;
}
